import {
	Breakpoints,
	Container,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	Image,
	CTA,
} from '@volkswagen-onehub/components-core';

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTrackingManager } from '../../../tracking/useTrackingManager';
import { PortalContext } from '../../../context/PortalContext';
import { Environment } from '../../../enviroment';
import { pageInPath } from '../../../tracking/trackingHelper';

const StyledContainer = styled.div`
	align-content: center;
	padding-top: var(--size-dynamic0130);

	@media screen and (min-width: 560px) {
		min-height: 70vh;
	}
`;

export const ConfirmVehicleClub: React.FC<{
	plate: string | null;
}> = ({ plate }) => {
	const trackingManager = useTrackingManager();

	useEffect(() => {
		pageInPath('add-vehicle/pending.app');
		trackingManager.trackClubVWGenericFeatureAppLoad({ contentId: 'add-vehicle/pending' }, {}, { vehicle: [] });
	}, []);

	const { navigationService } = React.useContext(PortalContext);
	const environmentPath = Environment.getInstance().garage;
	const target = navigationService.navigateTo(environmentPath, {});

	const handleNavigationOnClick = () => {
		if (target) {
			target.push();

			trackingManager.trackClubVWButtonClick('Ir a Mi garaje', { contentId: 'Navigate to My Garage' }, { vehicle: [] });
		}
	};

	return (
		<Container padding={{ top: ContainerPadding.dynamic0200, bottom: ContainerPadding.dynamic0200 }} stretchContent>
			<Container wrap={'always'} horizontalAlign={'center'} stretchContent>
				<Layout
					data-testid="confirm-club__logo-layout"
					appearance={{
						[Breakpoints.default]: [
							{ name: '.', columns: 7 },
							{ name: 'a', columns: 10 },
							{ name: '.', columns: 7 },
						],
						[Breakpoints.b560]: [
							{ name: '.', columns: 8 },
							{ name: 'a', columns: 8 },
							{ name: '.', columns: 8 },
						],
						[Breakpoints.b960]: [
							{ name: '.', columns: 10 },
							{ name: 'a', columns: 4 },
							{ name: '.', columns: 10 },
						],
						[Breakpoints.b1920]: [
							{ name: '.', columns: 11 },
							{ name: 'a', columns: 2 },
							{ name: '.', columns: 11 },
						],
					}}
				>
					<Image
						src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-club/logo_club.svg"
						alt="Logo club VW"
					/>
				</Layout>
			</Container>

			<StyledContainer className="confirm-club">
				<Layout
					data-testid="confirm-club__layout"
					appearance={{
						[Breakpoints.default]: [
							{ name: '.', columns: 0 },
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 0 },
							{ name: '.', columns: 1 },
							{ name: 'b', columns: 22 },
							{ name: '.', columns: 1 },
							{ name: '.', columns: 1 },
							{ name: 'c', columns: 22 },
							{ name: '.', columns: 1 },
						],
						[Breakpoints.b560]: [
							{ name: '.', columns: 0 },
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 0 },
							{ name: '.', columns: 2 },
							{ name: 'b', columns: 20 },
							{ name: '.', columns: 2 },
							{ name: '.', columns: 6 },
							{ name: 'c', columns: 12 },
							{ name: '.', columns: 6 },
						],
						[Breakpoints.b960]: [
							{ name: '.', columns: 0 },
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 0 },
							{ name: '.', columns: 4 },
							{ name: 'b', columns: 16 },
							{ name: '.', columns: 4 },
							{ name: '.', columns: 8 },
							{ name: 'c', columns: 8 },
							{ name: '.', columns: 8 },
						],
						[Breakpoints.b1280]: [
							{ name: '.', columns: 0 },
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 0 },
							{ name: '.', columns: 3 },
							{ name: 'b', columns: 18 },
							{ name: '.', columns: 3 },
							{ name: '.', columns: 9 },
							{ name: 'c', columns: 6 },
							{ name: '.', columns: 9 },
						],
						[Breakpoints.b1600]: [
							{ name: '.', columns: 0 },
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 0 },
							{ name: '.', columns: 5 },
							{ name: 'b', columns: 14 },
							{ name: '.', columns: 5 },
							{ name: '.', columns: 9 },
							{ name: 'c', columns: 6 },
							{ name: '.', columns: 9 },
						],
						[Breakpoints.b1920]: [
							{ name: '.', columns: 0 },
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 0 },
							{ name: '.', columns: 6 },
							{ name: 'b', columns: 12 },
							{ name: '.', columns: 6 },
							{ name: '.', columns: 10 },
							{ name: 'c', columns: 4 },
							{ name: '.', columns: 10 },
						],
						[Breakpoints.b2560]: [
							{ name: '.', columns: 0 },
							{ name: 'a', columns: 24 },
							{ name: '.', columns: 0 },
							{ name: '.', columns: 7 },
							{ name: 'b', columns: 10 },
							{ name: '.', columns: 7 },
							{ name: '.', columns: 10 },
							{ name: 'c', columns: 4 },
							{ name: '.', columns: 10 },
						],
					}}
				>
					<Container padding={{ bottom: ContainerPadding.dynamic0130 }} horizontalAlign={'center'}>
						<Image
							src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/order_car.gif"
							alt="VW gif"
						/>
					</Container>

					<Container padding={{ bottom: ContainerPadding.dynamic0250 }} horizontalAlign={'center'} wrap={'always'}>
						<Text
							appearance={TokenTextAppearance.headline400}
							textAlign={TextAlignment.center}
							color={TokenTextColor.primary}
						>
							¡Casi, casi!
						</Text>

						<Container padding={{ top: ContainerPadding.dynamic0130 }} horizontalAlign={'center'}>
							<Text
								appearance={TokenTextAppearance.bigcopy100}
								textAlign={TextAlignment.center}
								color={TokenTextColor.primary}
								bold
							>
								Estamos añadiendo tu coche con matrícula {plate} a tu perfil
							</Text>
							<Text
								appearance={TokenTextAppearance.bigcopy100}
								textAlign={TextAlignment.center}
								color={TokenTextColor.primary}
							>
								Créenos, nosotros también estamos deseando darte la bienvenida. Últimas comprobaciones y en menos de 48h
								te avisaremos por email.
							</Text>
						</Container>
						<Container padding={{ top: ContainerPadding.dynamic0130 }} horizontalAlign={'center'}>
							<Text
								appearance={TokenTextAppearance.bigcopy100}
								textAlign={TextAlignment.center}
								color={TokenTextColor.primary}
							>
								De momento, puedes descubrir los servicios de conectividad disponibles para tu coche desde tu garaje.
							</Text>
						</Container>
					</Container>

					<Container
						wrap={'always'}
						padding={{ bottom: ContainerPadding.dynamic0130 }}
						horizontalAlign={'center'}
						stretchContent
					>
						<CTA
							tag="button"
							emphasis="primary"
							aria-label="vamos"
							size="large"
							onClick={handleNavigationOnClick}
							stretchContent
						>
							Ir a Mi garaje
						</CTA>
					</Container>
				</Layout>
			</StyledContainer>
		</Container>
	);
};
